import type {
	CustomItem,
	DropComponentBackgroundType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropComponentBackground = (
	item: Item | CustomItem
): item is DropComponentBackgroundType => {
	return !!(item && item.__typename === 'Drop_Component_Background');
};
